import Modal from "src/components/common/Modal";
import { User } from "src/components/main/authStore";
import { useAuthStore } from "src/components/main/authStore";
import { 
    numberReducer
} from "src/components/common/functions";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { TimeOff } from "./types";
export default function BalanceForm(){
    const user = useAuthStore(state => state.user) as User;
    const navigate = useNavigate();
    const location = useLocation();
    const { timeOffs } = useOutletContext() as {timeOffs: TimeOff[]};
    return (
        <Modal
            touchOutsideClose = {true}
            closeIt = {() => navigate({ pathname: "..", search: location.search }, {replace: true})}
            title = "My Balance"
            width = {400}
            maxWidth = {"100%"}
        >
            <div className = "mt-2">
                <div className = "fw-bold">
                    Initial Value:
                    <span className = "mx-1 text-primary">
                        {0} hours
                    </span>
                    at {user.hireDate}
                </div>
                {timeOffs.filter(timeOff => timeOff.requesterId === user.id).map((timeOff, timeOffIndex) => 
                <li key = {timeOffIndex} className = "mt-2">
                    <span className = "text-info fw-bold">
                        {timeOff.requestDates}
                    </span>
                    <span className = "ms-1 text-primary fw-bold">
                        {timeOff.totalHours ?? 0}hours
                    </span>
                </li>
                )}
                <div className = "mt-2 fw-bold">
                    Current Value:
                    <span className = "ms-1 text-primary">
                        {0 - timeOffs.filter(timeOff => timeOff.requesterId === user.id)
                        .map(timeOff => timeOff.totalHours ?? 0).reduce(numberReducer, 0)}
                        &nbsp;
                        hours
                    </span>
                </div>
            </div>
        </Modal>
    )
}